import { Injectable, TemplateRef } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class ToolbarService {
  public template = new ReplaySubject<TemplateRef<any>>();
}
